<template>
  <v-btn 
    :class="['btnNormal']" 
    :color="color"
    :style="{
      backgroundColor: `${color} !important`, 
      border: `1px solid ${borderColor} !important`
    }"
    :disabled="disabled"
    elevation="0"
    @click="$emit('click')" 
  >
    <span :class="[`${showClassColor(textColor)}`, 'letter-spacing']" :style="`${showStyleColor(textColor)}; font-size: ${textSize};`">
      {{label}}
    </span>
    <v-icon v-if="icon" :color="textColor" class="pl-2" size="11">
      {{icon}}
    </v-icon>
  </v-btn>
</template>

<script>
  export default {
    props: {
      label: {type: String, default: 'Botão'},
      color: {type: String, default: '#F0F8FF' },
      borderColor: {type: String, default: '#B9E2FE'},
      textColor: {type: String, default: 'white'},
      textSize: {type: String, default: '0.85rem'},
      icon: {type: String, default: 'fa-solid fa-plus'},
      disabled: {type: Boolean, default: false}
    },

    methods: {
      showClassColor (color) {
        if (color && !color.includes('#') && !color.includes('rgb')) return `${color}--text`
        else return ''
      },

      showStyleColor (color) {
        if (color && (color.includes('#') || color.includes('rgb'))) return `color: ${color} !important`
        else return ''        
      }
    }
  }
</script>

<style scoped>
.btnNormal {
  text-transform: none !important;
  height: 32px !important;
  border-radius: 4px !important;
  padding: 0px 10px 0px 10px !important;
  color: white !important;
}

.letter-spacing {
  letter-spacing: 0.05rem;
}
</style>
